import {
  Create,
  SimpleForm,
  ImageInput,
  ImageField,
  TextInput,
  PasswordInput
} from "react-admin";
import {
  file,
  hasValue,
  cnpj,
  email
} from "../../utils/schemas";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import CustomSaveToolbar from "../../ui/custom-save-toolbar";
import MaskTextInput from "../../inputs/mask-text-input";

const Schema = Yup.object(
{
  image: file(),
  name: hasValue(),
  register_number: cnpj(),
  responsibility_name: hasValue(),
  responsibility_email: email(),
  password: hasValue()
});

const EnterpriseCreate = () =>
{
  return (
    <Create title="Nova Empresa" redirect="list">
      <SimpleForm
        noValidate
        resolver={yupResolver(Schema)}
        toolbar={<CustomSaveToolbar />} >
        <Grid container columnSpacing={2} width="100%">
          <Grid size={{ xs: 6 }}>
            <ImageInput source="image" label="Logo (.jpg)" accept={{ 'image/jpg,image/jpeg': ['.jpeg', '.jpg'] }} fullWidth isRequired >
              <ImageField source="src" title="title" />
            </ImageInput>
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <TextInput source="name" label="Nome" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }} style={{ marginBottom: 20 }}>
            <MaskTextInput source="register_number" label="CNPJ" mask="##.###.###/####-##" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <TextInput source="responsibility_name" label="Nome Responsável" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 3 }}>
            <TextInput source="responsibility_email" label="E-mail Login" type="email" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 3 }}>
            <PasswordInput source="password" label="Senha" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />
        </Grid>
      </SimpleForm>
    </Create>
  );
};

export default EnterpriseCreate;
